import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useQuery, useQueryClient } from "react-query";
import Swal from "sweetalert2";
import Loader from "../../../Shared/Loader";
import { apiConnectorGet, apiConnectorPost } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import { areYouSureFn } from "../../../utils/utilityFun";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo1 from "../../../assets/logo.png";

function FundTransferToToupWallet() {
  const client = useQueryClient();
  const [sponsername, setSponsername] = useState("");
  const navigate = useNavigate();
  const [loding, setLoding] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const fk = useFormik({
    initialValues: { transfer_amount: "", customer_id: "", wallet_type: "fund" },
  });

  async function sendTokenTransaction() {
    if (!fk.values.transfer_amount || Number(fk.values.transfer_amount) <= 0) {
      Swal.fire({ text: "Please enter a valid transfer amount", confirmButtonColor: "#2563EB", icon: "warning" });
      return;
    }
    if (!fk.values.customer_id || String(fk.values.customer_id).trim() === "") {
      Swal.fire({ text: "Please enter Customer Id", confirmButtonColor: "#2563EB", icon: "warning" });
      return;
    }
    if (Number(user_profile?.tr03_fund_wallet || 0) < Number(fk.values.transfer_amount || 0)) {
      Swal.fire({ text: "Insufficient fund in your wallet", confirmButtonColor: "#2563EB", icon: "warning" });
      return;
    }

    setLoding(true);
    try {
      const payload = {
        pkg_amount: fk.values.transfer_amount,
        pkg_id: 1,
        to_cust_id: fk.values.customer_id,
        wallet_type: fk.values.wallet_type === "fund" ? "fund_wallet" : "topup_wallet",
      };

      const res = await apiConnectorPost(endpoint?.member_fund_transfer, payload);
      if (res?.data?.success) {
        Swal.fire({ icon: "success", text: res?.data?.message || "Transfer submitted", confirmButtonColor: "#2563EB" });
        fk.handleReset();
        client.invalidateQueries("profile_api");
        client.invalidateQueries("get_actiavtion");
        navigate("/fund-transfer-history");
      } else {
        Swal.fire({ icon: "warning", text: res?.data?.message || "Transfer failed", confirmButtonColor: "#2563EB" });
      }
    } catch (error) {
      console.error(error);
      toast("Error connecting...");
    }
    setLoding(false);
  }

  const { data: profile_data } = useQuery(
    ["profile_api"],
    () => apiConnectorGet(endpoint?.profile_api),
    { refetchOnMount: false, refetchOnReconnect: false, retry: false, retryOnMount: false, refetchOnWindowFocus: false }
  );
  const user_profile = profile_data?.data?.result?.[0] || [];

  const getSponserName = async () => {
    try {
      const response = await axios.post(
        endpoint?.get_spon_name,
        { customer_id: fk.values.customer_id },
        { headers: { "Content-Type": "application/json", "Access-Control-Allow-Origin": "*" } }
      );
      setSponsername(
        response?.data?.success
          ? response?.data?.result?.[0]?.lgn_name
          : "Invalid Sponser"
      );
    } catch {
      setSponsername("Error fetching sponser");
    }
  };

  useEffect(() => {
    if (fk.values.customer_id) getSponserName();
    else setSponsername("");
  }, [fk.values.customer_id]);

  return (
    <>
      <Loader isLoading={loding} />

      {/* ── Full-page background ── */}
      <div
        className="min-h-screen relative flex items-center justify-center py-10 px-4 overflow-x-hidden"
        style={{ background: "linear-gradient(160deg, #060E1C 0%, #080F1C 50%, #0B1E36 100%)" }}
      >
        {/* Grid overlay */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage:
              "linear-gradient(rgba(37,99,235,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(37,99,235,0.03) 1px, transparent 1px)",
            backgroundSize: "40px 40px",
          }}
        />

        {/* Animated blobs */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full blur-[120px] pointer-events-none"
          style={{ background: "radial-gradient(ellipse, rgba(37,99,235,0.12) 0%, transparent 70%)" }} />
        <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full blur-3xl pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(29,78,216,0.08) 0%, transparent 70%)" }} />

        {/* Particles */}
        {[...Array(6)].map((_, i) => (
          <div key={i}
            className="absolute w-1 h-1 rounded-full bg-[#2563EB]/40 animate-ping pointer-events-none"
            style={{
              top: `${15 + i * 13}%`,
              left: `${8 + i * 14}%`,
              animationDelay: `${i * 0.7}s`,
              animationDuration: "3s",
            }}
          />
        ))}

        {/* ── Card ── */}
        <div
          className="relative w-full max-w-md min-w-0 rounded-2xl overflow-hidden"
          style={{
            background: "linear-gradient(145deg, rgba(7,21,38,0.95) 0%, rgba(8,15,28,0.95) 60%, rgba(11,30,54,0.95) 100%)",
            border: "1px solid rgba(37,99,235,0.25)",
            boxShadow: "0 0 0 1px rgba(37,99,235,0.08), 0 25px 60px rgba(0,0,0,0.6), 0 0 80px rgba(37,99,235,0.08)",
          }}
        >
          {/* Top accent */}
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#2563EB]/70 to-transparent" />
          {/* Left accent bar */}
          <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#22D3EE] via-[#2563EB] to-[#1D4ED8]" />
          {/* Corner decorations */}
          <div className="absolute top-0 right-0 w-28 h-28 border-t border-r border-[#2563EB]/15 rounded-tr-2xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-20 h-20 border-b border-l border-[#1D4ED8]/10 rounded-bl-2xl pointer-events-none" />
          {/* Glow blobs inside card */}
          <div className="absolute top-0 right-0 w-48 h-48 rounded-full blur-3xl pointer-events-none"
            style={{ background: "radial-gradient(circle, rgba(37,99,235,0.10) 0%, transparent 70%)" }} />
          <div className="absolute bottom-0 left-0 w-40 h-40 rounded-full blur-2xl pointer-events-none"
            style={{ background: "radial-gradient(circle, rgba(29,78,216,0.07) 0%, transparent 70%)" }} />

          <div className="relative z-10 p-7">

            {/* ── Logo Header ── */}
            <div className="flex flex-col items-center mb-7">
              <div className="relative mb-3">
                <div className="absolute inset-0 bg-[#2563EB]/30 rounded-2xl blur-lg" />
                <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-[#2563EB]/20 to-[#1D4ED8]/20 border border-[#2563EB]/40 flex items-center justify-center">
                  <img src={logo1} alt="logo" className="w-9 h-9 object-contain drop-shadow" />
                </div>
              </div>
              <h2 className="text-white font-extrabold text-xl tracking-wide">P2P Transfer</h2>
              <p className="text-[#475569] text-xs mt-1 tracking-wide">Transfer funds to another member</p>
              <div className="mt-3 flex items-center gap-2">
                <span className="px-2.5 py-0.5 rounded-full text-[10px] font-semibold border border-[#2563EB]/30 text-[#7DD3FC] bg-[#2563EB]/10">
                  BNB Smart Chain
                </span>
                <span className="px-2.5 py-0.5 rounded-full text-[10px] font-semibold border border-[#1e3a5f]/50 text-[#475569] bg-[#060E1C]/60">
                  USDT BEP-20
                </span>
              </div>
            </div>

            {/* ── Wallet Balance Card ── */}
            <div
              className="relative rounded-xl p-4 mb-6 overflow-hidden"
              style={{
                background: "linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(29,78,216,0.08) 100%)",
                border: "1px solid rgba(37,99,235,0.25)",
              }}
            >
              <div className="absolute top-0 right-0 w-24 h-24 rounded-full blur-2xl pointer-events-none"
                style={{ background: "radial-gradient(circle, rgba(34,211,238,0.08) 0%, transparent 70%)" }} />
              <div className="flex items-center justify-between relative z-10">
                <div>
                  <p className="text-[#475569] text-[10px] uppercase tracking-widest font-semibold mb-1">Fund Wallet Balance</p>
                  <p className="text-white font-extrabold text-2xl">
                    <span className="text-[#22D3EE] text-lg mr-1">$</span>
                    {Number(user_profile?.tr03_fund_wallet || 0).toFixed(2)}
                  </p>
                </div>
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#2563EB] to-[#1D4ED8] flex items-center justify-center shadow-[0_0_16px_rgba(37,99,235,0.4)]">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                  </svg>
                </div>
              </div>
              <div className="mt-3 h-px bg-gradient-to-r from-transparent via-[#2563EB]/30 to-transparent" />
              <p className="text-[#334155] text-[10px] mt-2 relative z-10">Available for transfer to members</p>
            </div>

            {/* ── Wallet Type Selector ── */}
            <div className="mb-5">
              <p className="text-[#475569] text-[10px] uppercase tracking-widest font-semibold mb-2.5">Transfer To</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { value: "fund", label: "Fund Wallet" },
                  { value: "topup", label: "Topup Wallet" },
                ].map((opt) => (
                  <label
                    key={opt.value}
                    className={`flex items-center gap-2.5 p-3 rounded-xl border cursor-pointer transition-all duration-200 ${
                      fk.values.wallet_type === opt.value
                        ? "border-[#2563EB]/60 bg-[#2563EB]/10 text-white"
                        : "border-[#1e3a5f]/50 bg-[#060E1C]/40 text-[#64748B] hover:border-[#1e3a5f] hover:text-[#94A3B8]"
                    }`}
                  >
                    <input
                      type="radio"
                      name="wallet_type"
                      value={opt.value}
                      onChange={fk.handleChange}
                      checked={fk.values.wallet_type === opt.value}
                      className="hidden"
                    />
                    <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                      fk.values.wallet_type === opt.value
                        ? "border-[#2563EB]"
                        : "border-[#334155]"
                    }`}>
                      {fk.values.wallet_type === opt.value && (
                        <div className="w-2 h-2 rounded-full bg-[#2563EB]" />
                      )}
                    </div>
                    <span className="text-xs font-semibold">{opt.label}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* ── Amount Input ── */}
            <div className="mb-4">
              <label className="text-[#475569] text-[10px] uppercase tracking-widest font-semibold block mb-2">
                Transfer Amount (USDT)
              </label>
              <div className="relative">
                <div className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#2563EB] font-bold text-sm pointer-events-none">$</div>
                <input
                  type="number"
                  placeholder="0.00"
                  id="transfer_amount"
                  name="transfer_amount"
                  value={fk.values.transfer_amount}
                  onChange={fk.handleChange}
                  className="w-full pl-8 pr-4 py-3 rounded-xl text-white text-base font-semibold placeholder-[#334155] focus:outline-none transition-all duration-200"
                  style={{
                    background: "rgba(6,14,28,0.8)",
                    border: "1px solid rgba(30,58,95,0.6)",
                  }}
                  onFocus={(e) => {
                    e.target.style.border = "1px solid rgba(37,99,235,0.6)";
                    e.target.style.boxShadow = "0 0 0 3px rgba(37,99,235,0.12)";
                  }}
                  onBlur={(e) => {
                    e.target.style.border = "1px solid rgba(30,58,95,0.6)";
                    e.target.style.boxShadow = "none";
                  }}
                />
                <div className="absolute right-3.5 top-1/2 -translate-y-1/2 text-[#334155] text-xs font-semibold">USDT</div>
              </div>
            </div>

            {/* ── Customer ID Input ── */}
            <div className="mb-6">
              <label className="text-[#475569] text-[10px] uppercase tracking-widest font-semibold block mb-2">
                Recipient Customer ID
              </label>
              <input
                type="text"
                placeholder="Enter Customer ID"
                id="customer_id"
                name="customer_id"
                value={fk.values.customer_id}
                onChange={fk.handleChange}
                className="w-full px-4 py-3 rounded-xl text-white text-sm font-semibold placeholder-[#334155] focus:outline-none transition-all duration-200"
                style={{
                  background: "rgba(6,14,28,0.8)",
                  border: "1px solid rgba(30,58,95,0.6)",
                }}
                onFocus={(e) => {
                  e.target.style.border = "1px solid rgba(37,99,235,0.6)";
                  e.target.style.boxShadow = "0 0 0 3px rgba(37,99,235,0.12)";
                }}
                onBlur={(e) => {
                  e.target.style.border = "1px solid rgba(30,58,95,0.6)";
                  e.target.style.boxShadow = "none";
                }}
              />
              {/* Sponsor name feedback */}
              {sponsername && (
                <div className={`mt-2 flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium ${
                  sponsername === "Invalid Sponser" || sponsername === "Error fetching sponser"
                    ? "bg-red-500/10 border border-red-500/20 text-red-400"
                    : "bg-emerald-500/10 border border-emerald-500/20 text-emerald-400"
                }`}>
                  {sponsername === "Invalid Sponser" || sponsername === "Error fetching sponser" ? (
                    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                  {sponsername}
                </div>
              )}
            </div>

            {/* ── Submit Button ── */}
            <button
              onClick={() => areYouSureFn(Swal, sendTokenTransaction, {})}
              className="relative w-full py-3.5 rounded-xl font-bold text-sm text-white overflow-hidden group transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
              style={{
                background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
                boxShadow: "0 0 20px rgba(37,99,235,0.35)",
              }}
            >
              {/* Shimmer */}
              <div className="absolute inset-0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 bg-gradient-to-r from-transparent via-white/10 to-transparent" />
              <div className="relative z-10 flex items-center justify-center gap-2">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                </svg>
                Submit Transfer
              </div>
            </button>

            {/* ── Back link ── */}
            <button
              onClick={() => navigate(-1)}
              className="mt-4 w-full flex items-center justify-center gap-1.5 text-[#475569] hover:text-[#7DD3FC] text-xs font-medium transition-colors duration-200"
            >
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Go Back
            </button>

          </div>
        </div>
      </div>
    </>
  );
}

export default FundTransferToToupWallet;
